// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-input-content{position:absolute;right:45px;top:9px;cursor:pointer;z-index:9}.container-form-control{display:flex;align-content:center;justify-content:center;width:100%;position:relative}.container-form-control input{border-radius:0}.container-form-control .input-group-append .btn{border-radius:0}\n", ""]);
// Exports
module.exports = exports;
